document.addEventListener("DOMContentLoaded", function () {
	const headers = document.querySelectorAll(".accordion-header");

	headers.forEach((header) => {
		header.addEventListener("click", function () {
			const button = this.querySelector(".accordion-button");
			const content = this.nextElementSibling;
			const isActive = content.classList.contains("active");

			// Close all other accordion items
			document.querySelectorAll(".accordion-content").forEach((item) => {
				item.classList.remove("active");
			});

			// Reset the accordion buttons
			document.querySelectorAll(".accordion-button").forEach((item) => {
				item.classList.remove("active");
			});

			// Toggle the clicked item
			if (!isActive) {
				content.classList.add("active");
				button.classList.add("active");
			} else {
				content.classList.remove("active");
				button.classList.remove("active");
			}
		});
	});
});
